import {PROJECT_BASE_PATH} from '../workspace/multiRunWorkspacePaths';

export const ARTIFACT_VERSION_PATH = `${PROJECT_BASE_PATH}/artifacts/:artifactTypeName/:artifactCollectionName/:artifactCommitHash`;

export const PROJECT_ARTIFACTS_TAB = `${PROJECT_BASE_PATH}/:tab(artifacts)`;

export const PROJECT_ARTIFACT_NEW_TYPE_PATH = `${PROJECT_ARTIFACTS_TAB}/:artifactTypeName(new)`;
export const PROJECT_ARTIFACT_TYPE_PATH = `${PROJECT_ARTIFACTS_TAB}/:artifactTypeName`;
export const PROJECT_ARTIFACT_NEW_VERSION_PATH = `${PROJECT_ARTIFACTS_TAB}/:artifactTypeName/:artifactCommitHash(new)`;
export const PROJECT_ARTIFACT_COLLECTION_VIEW_PATH = `${PROJECT_ARTIFACTS_TAB}/:artifactTypeName/:artifactCollectionName/_view/:artifactCollectionView`;
export const PROJECT_ARTIFACT_VERSION_FILES_PATH = `${PROJECT_ARTIFACTS_TAB}/:artifactTypeName/:artifactCollectionName/:artifactCommitHash/:artifactTab(files)/:filePath*`;
export const PROJECT_ARTIFACT_VERSION_LINEAGE_PATH = `${PROJECT_ARTIFACTS_TAB}/:artifactTypeName/:artifactCollectionName/:artifactCommitHash/:artifactTab(lineage)`;
export const PROJECT_ARTIFACT_VERSION_TAB_PATH = `${PROJECT_ARTIFACTS_TAB}/:artifactTypeName/:artifactCollectionName/:artifactCommitHash/:artifactTab?`;
export const PROJECT_ARTIFACT_COLLECTION_PATH = `${PROJECT_ARTIFACTS_TAB}/:artifactTypeName/:artifactCollectionName`;

export const PROJECT_ARTIFACT_PATHS = [
  PROJECT_ARTIFACT_NEW_TYPE_PATH,
  PROJECT_ARTIFACT_TYPE_PATH,
  PROJECT_ARTIFACT_NEW_VERSION_PATH,
  PROJECT_ARTIFACT_COLLECTION_VIEW_PATH,
  PROJECT_ARTIFACT_VERSION_FILES_PATH,
  PROJECT_ARTIFACT_VERSION_LINEAGE_PATH,
  PROJECT_ARTIFACT_VERSION_TAB_PATH,
  PROJECT_ARTIFACT_COLLECTION_PATH,
];
